import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import "./mansioni.css";

const EditMansioni = () => {
  const [loading, setLoading] = useState(true);
  const [mansione, setMansione] = useState(null);

  const [form, setForm] = useState({
    nomeMansione: "",
    descrizioneMansione: "",
  });

  const [errors, setErrors] = useState({});
  const [editMode, setEditMode] = useState(false);

  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");

    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per modificare le mansioni!");

      navigate("/login");
      localStorage.clear();
      return;
    }

    if (location.state?.mansioni) {
      const data = location.state.mansioni;
      setMansione(data);
      setForm({
        nomeMansione: data.nomeMansione || "",
        descrizioneMansione: data.descrizioneMansione || "",
      });
      setLoading(false);
    } else {
      toast.error("Dati mansione non trovati!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setLoading(false);
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (errors[name] && value.trim() !== "") {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const validate = () => {
    const inputErrors = {};
    if (!form.nomeMansione.trim()) {
      inputErrors.nomeMansione = "Il campo Nome Mansione non può essere vuoto!";
    }

    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;

    try {
      setLoading(true);
      const response = await api.put(`/mansioni/${id}`, {
        nomeMansione: form.nomeMansione,
        descrizioneMansione: form.descrizioneMansione,
      });
      if (response.status === 200) {
        toast.success("Modifiche salvate con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setMansione({ ...mansione, ...form });
        setEditMode(false);
      }
    } catch (error) {
      console.error(error);

      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (mansione) {
      setForm({
        nomeMansione: mansione.nomeMansione || "",
        descrizioneMansione: mansione.descrizioneMansione || "",
      });
    }
    setErrors({});
    setEditMode(false);
  };

  if (loading || !mansione) return <div>Caricamento...</div>;

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Modifica Mansione</div>
        <div className="header-actions">
          <button onClick={() => navigate("/mansioni")} className="back-btn">
            <i className="fa-solid fa-arrow-left"></i>
            Torna alle Mansioni
          </button>
        </div>
      </div>

      <div className="page-content edit-mansioni">
        <div className="form-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-edit"></i>
              {editMode ? "Modifica Mansione" : "Dettagli Mansione"}
            </div>
            {!editMode && (
              <button className="edit-btn" onClick={() => setEditMode(true)}>
                <i className="fa-solid fa-edit"></i>
                Modifica
              </button>
            )}
          </div>

          <div className="card-content">
            <div className="form-field">
              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-briefcase"></i>
                  Nome Mansione
                </label>
                <div className="form-input">
                  {editMode ? (
                    <input
                      id="nomeMansione"
                      name="nomeMansione"
                      value={form.nomeMansione}
                      onChange={handleChange}
                      placeholder="Inserisci il nome della mansione"
                      className="modern-input"
                    />
                  ) : (
                    <div className="display-value">{form.nomeMansione}</div>
                  )}
                  {errors.nomeMansione && (
                    <span className="error-message">{errors.nomeMansione}</span>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-align-left"></i>
                  Descrizione Mansione
                </label>
                <div className="form-input">
                  {editMode ? (
                    <textarea
                      id="descrizioneMansione"
                      name="descrizioneMansione"
                      value={form.descrizioneMansione}
                      onChange={handleChange}
                      placeholder="Inserisci una descrizione dettagliata della mansione"
                      className="modern-textarea"
                      rows={6}
                    />
                  ) : (
                    <div className="display-value">
                      {form.descrizioneMansione}
                    </div>
                  )}
                  {errors.descrizioneMansione && (
                    <span className="error-message">
                      {errors.descrizioneMansione}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {!editMode && (
              <div className="info-section">
                <div className="info-item">
                  <i className="fa-solid fa-info-circle"></i>
                  <span>ID Mansione: {mansione.idMansione}</span>
                </div>
              </div>
            )}
          </div>

          {editMode && (
            <div className="card-actions">
              <button className="cancel-btn" onClick={handleCancel}>
                <i className="fa-solid fa-times"></i>
                Annulla
              </button>
              <button className="save-btn" onClick={handleSave}>
                <i className="fa-solid fa-save"></i>
                Salva Modifiche
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditMansioni;
